// ========================================
// COMPONENTE - ERROR AL FIRMAR
// ========================================

interface SignatureErrorViewProps {
    message: string;
    onRetry: () => void;
}

const SignatureErrorView = ({ message, onRetry }: SignatureErrorViewProps) => {
    return (
        <div className="min-h-screen bg-gray-50 p-3 sm:p-4">
        <div className="max-w-md mx-auto mt-20">
        <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 w-full text-center">
            <div className="flex justify-center mb-4">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-red-100 rounded-full flex items-center justify-center">
                <svg className="w-10 h-10 sm:w-12 sm:h-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
            </div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
            Error al Firmar
            </h2>
            <p className="text-sm sm:text-base text-gray-600 mb-4">
            {message}
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <p className="text-xs sm:text-sm text-yellow-800">
                Si el problema persiste, contacte con el centro.
            </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 justify-center">
            <button
                onClick={onRetry}
                className="w-full sm:w-auto bg-blue-600 text-white px-4 sm:px-6 py-2 text-sm sm:text-base rounded-lg hover:bg-blue-700 transition"
            >
                🔄 Reintentar
            </button>
            <button
                onClick={() => window.location.href = 'mailto:info@bienesys.com'}
                className="w-full sm:w-auto bg-gray-600 text-white px-4 sm:px-6 py-2 text-sm sm:text-base rounded-lg hover:bg-gray-700 transition"
            >
                Contactar Soporte
            </button>
            </div>
        </div>
        </div>
        </div>
    );
};

export default SignatureErrorView;
